import Box from "@mui/material/Box";

/** Overlay guide side as a percent of the video container. */
const ROI_SIZE = 50; // percent

/**
 * Centred ROI guide drawn over the live camera video.
 *
 * Mirrors the actual decode region used by the `qr`/`both` and `barcode`
 * backends: a square covering the central 50% of the frame. It pulses the
 * border while a scan is in progress.
 *
 * @param scanning - whether the camera loop is currently running.
 */
export function ScanOverlay({ scanning }: { scanning?: boolean }) {
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
      }}
    >
      <Box
        data-testid="scan-overlay"
        sx={{
          width: `${ROI_SIZE}%`,
          aspectRatio: "1/1",
          border: "2px solid",
          borderColor: scanning ? "primary.main" : "rgba(255,255,255,0.6)",
          borderRadius: 1,
          transition: "border-color 0.3s",
          boxShadow: "0 0 0 9999px rgba(0,0,0,0.35)",
        }}
      />
    </Box>
  );
}
